import { currentFeatures } from "@/configs/Settings";
import { useFormatter } from "@/utils/useFormatter";

/**
 * Resolve patientId no mesmo formato de navigate("/summary") e DocumentReissueShortcutDialog.
 * Espelha resolvePatientId de PatientSearchActions.
 */
export function resolveReissuePatientId(identifier?: string): string {
  if (!identifier) return "";
  return currentFeatures.defaultApp
    ? identifier.replace(/[^a-zA-Z0-9]/g, "")
    : identifier;
}

/** Extrai nome + identifier de um Patient FHIR para o passo de seleção. */
export function mapPatientEntryToSearchRow(
  entry: fhir5.BundleEntry<fhir5.Patient>,
) {
  const resource = entry.resource;
  const patientResourceId = resource?.id || "";
  // ID FHIR costuma ser `{oid}-{cpf}` no defaultApp
  const rawCpfFromId =
    currentFeatures.defaultApp && patientResourceId.includes("-")
      ? patientResourceId.split("-").slice(1).join("-") || ""
      : "";

  const identifier = currentFeatures.defaultApp
    ? useFormatter.formatCPF(rawCpfFromId)
    : resource?.identifier?.[0]?.value || "";

  const auxName =
    resource?.name?.find((n) => n.use === "usual" || n.use === "official")
      ?.text ||
    resource?.name?.[0]?.text ||
    "-";
  const name = useFormatter.formatNameDisplay(auxName) || "-";

  // Preferir dígitos do ID (mais estável); fallback no identifier formatado
  const patientId = currentFeatures.defaultApp
    ? rawCpfFromId.replace(/[^a-zA-Z0-9]/g, "") ||
      resolveReissuePatientId(identifier)
    : resolveReissuePatientId(identifier) || patientResourceId;

  return {
    patientResourceId,
    identifier,
    name,
    patientId,
  };
}

export type ReissuePatientOption = ReturnType<typeof mapPatientEntryToSearchRow>;
